import { supabase } from "./supabase";

// O IO das páginas públicas dos CURSOS GRATUITOS ao vivo (000380), que eram o certificados-cf.
// ZERO regra: quem diz se o curso está aberto, se a aula existe, se a presença vale e se o
// certificado sai é o banco, e a tela mostra a frase dele. As quatro portas são executáveis pelo
// anônimo: quem assina a presença e emite o certificado não tem conta no hub.

export type CursoPublico = {
  slug: string;
  nome: string;
  carga_horaria: number;
  num_aulas: number;
  data: string;
  requer_presenca: boolean;
  exige_presenca_total: boolean;
};
export type AulaPublica = { numero: number; titulo: string | null; data: string; hora: string } | null;

export type Recusa = { ok: false; motivo: string; mensagem: string };

export type CertificadoPublico = {
  ok: true;
  token: string;
  nome: string;
  emitido_em: string;
  revogado: boolean;
  curso: string;
  carga_horaria: number;
  data: string;
};

const FALHA: Recusa = {
  ok: false,
  motivo: "falha",
  mensagem: "Não foi possível falar com o servidor agora. Confira a conexão e tente de novo.",
};

async function chamar<T>(funcao: string, args: Record<string, unknown>): Promise<T | Recusa> {
  const { data, error } = await supabase.rpc(funcao, args);
  if (error || !data) return FALHA;
  return data as T | Recusa;
}

/** O curso ativo e, se pedida, a agenda da aula. */
export function lerCurso(slug: string, aula?: number) {
  return chamar<{ ok: true; curso: CursoPublico; aula: AulaPublica }>("cg_curso_publico", {
    p_slug: slug,
    p_aula: aula ?? null,
  });
}

export function assinarPresenca(slug: string, aula: number, nome: string, email: string, telefone: string) {
  return chamar<{ ok: true; ultima: boolean; num_aulas: number }>("cg_assinar_presenca", {
    p_slug: slug,
    p_aula: aula,
    p_nome: nome,
    p_email: email,
    p_telefone: telefone,
  });
}

/** Emite, ou devolve o certificado que o e-mail já tem (`ja_emitido`). */
export function emitirCertificado(slug: string, nome: string, email: string) {
  return chamar<{ ok: true; token: string; nome: string; ja_emitido: boolean }>("cg_emitir_certificado", {
    p_slug: slug,
    p_nome: nome,
    p_email: email,
  });
}

/** O certificado pelo token: é o que a página do certificado e a validação leem. */
export function lerCertificado(token: string) {
  return chamar<CertificadoPublico>("cg_certificado", { p_token: token });
}

/** O endereço que o QR do certificado leva: a validação, no hub. */
export function enderecoDaValidacao(token: string): string {
  return `${window.location.origin}/certificados/verificar/${token}`;
}

/**
 * Quem assinou a presença neste navegador, por curso: a página de emitir já abre com o nome e o
 * e-mail. É conveniência da pessoa (a de lá fazia igual); o certificado continua saindo só pela
 * presença que o banco tem.
 */
export const lembrarQuemAssinou = {
  ler(slug: string): { nome: string; email: string } | null {
    try {
      const v = JSON.parse(sessionStorage.getItem(`cg:quem:${slug}`) ?? "null");
      return v && typeof v.nome === "string" && typeof v.email === "string" ? v : null;
    } catch {
      return null;
    }
  },
  guardar(slug: string, quem: { nome: string; email: string }) {
    try {
      sessionStorage.setItem(`cg:quem:${slug}`, JSON.stringify(quem));
    } catch {
      // sem armazenamento (navegação privada): a página só não abre preenchida
    }
  },
};
